import { useQuery } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DialogContent, DialogHeader, DialogFooter } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import * as yup from 'yup';
import { CompanyRoleEnum2 as CompanyRoleEnum } from 'shared/domains/apollo/generated/types';
import { CancelButton, Fieldset, FormDialog, SubmitButton, SwitchField, TextAreaField, TextField, } from 'shared/domains/forms';
import { useAccount } from 'shared/domains/users';
import { DashboardFormDocument } from './DashboardForm.gql';
export function DashboardForm(props) {
    const { onSubmit, onClose, id } = props;
    const account = useAccount();
    const { data, error, loading } = useQuery(DashboardFormDocument, {
        skip: !id,
        variables: {
            id: id || '',
        },
    });
    const isOwner = account.data.role === CompanyRoleEnum.Owner;
    const { searchInsightsDashboard } = data || {};
    const initialValues = {
        label: (searchInsightsDashboard === null || searchInsightsDashboard === void 0 ? void 0 : searchInsightsDashboard.label) || '',
        description: (searchInsightsDashboard === null || searchInsightsDashboard === void 0 ? void 0 : searchInsightsDashboard.description) || '',
        isPublic: (searchInsightsDashboard === null || searchInsightsDashboard === void 0 ? void 0 : searchInsightsDashboard.isPublic) || false,
    };
    const validationSchema = yup.object({
        label: yup
            .string()
            .required(t({ message: 'Label is required', comment: 'Insights dashboard form: Label validation' })),
        description: yup.string(),
        isPublic: yup.bool(),
    });
    const title = id
        ? t({ message: 'Edit dashboard', comment: 'Insights dashboard form: Header' })
        : t({ message: 'New dashboard', comment: 'Insights dashboard form: Header' });
    return (<FormDialog state={{ loading, error: !!error }} initialValues={initialValues} onSubmit={onSubmit} onClose={onClose} validationSchema={validationSchema}>
      <DialogHeader title={title}/>
      <DialogContent>
        <Fieldset>
          <TextField name="label" autoComplete="off" label={t({ message: 'Name', comment: 'Insights dashboard form: name' })}/>

          <TextAreaField autosizeHeight name="description" label={t({ message: 'Description', comment: 'Insights dashboard form: description' })}/>

          {isOwner && (<SwitchField icon={<Falcon icon="eye"/>} label="Public" name="isPublic" title="Public" subtitle="If the dashboard should be public to all users in the company"/>)}
        </Fieldset>
      </DialogContent>
      <DialogFooter>
        <CancelButton onClick={onClose}>
          <Trans comment="Insights dashboard form: Cancel button">Cancel</Trans>
        </CancelButton>
        <SubmitButton>
          <Trans comment="Insights dashboard form: Submit button">Submit</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
